import { isArray, isArrayEmpty } from 'utility/helpers';
import {
  DEFAULT_DOCUMENT_EXPIRY_NOTIFICATION_PERIOD,
  DOCUMENT_TYPE_FIELDS,
  NEW_DOCUMENT_TYPE_VALUES,
} from '../../../constants/documentTypes';
import { FIELD_TYPES } from '../../../constants/fieldTypes';
import {
  forbiddenCharacters,
  isEmpty,
  validateFieldsInList,
  validateLength,
} from '../../../utility/validation';

export const prepareInitialData = (category = {}) => {
  return {
    name: category.name,
    expire_warning_days:
      category.expire_warning_days ||
      DEFAULT_DOCUMENT_EXPIRY_NOTIFICATION_PERIOD,
    types: category.types,
  };
};

export const prepareDocumentCategoryFields = classes => [
  {
    name: 'name',
    type: FIELD_TYPES.TEXT,
    fieldWrapperClass: classes.categoryName,
    required: true,
    validators: [
      {
        type: 'required',
        validator: isEmpty,
      },
      {
        type: 'forbiddenCharacters',
        validator: forbiddenCharacters,
      },
      {
        type: 'maxLength',
        validator: fieldValue => validateLength(fieldValue, 0, 128),
      },
    ],
  },
  {
    name: 'expire_warning_days',
    translationKey: 'notifyBefore',
    type: FIELD_TYPES.SELECT,
    optionsKey: 'notifyBeforeOptions',
    fieldWrapperClass: classes.notifyBefore,
    isSearchDisabled: true,
    required: true,
    parser: {
      value: 'id',
      label: 'name',
    },
    validators: [
      {
        type: 'required',
        validator: isEmpty,
      },
    ],
  },
  {
    name: 'subtitle',
    type: FIELD_TYPES.SUBTITLE,
    fieldWrapperClass: classes.documentSubtitle,
  },
  {
    name: 'types',
    translationKey: 'documentTypes',
    fieldWrapperClass: classes.documentTypes,
    type: FIELD_TYPES.DOCUMENT_TYPE_FIELDS,
    initialValues: NEW_DOCUMENT_TYPE_VALUES,
    required: true,
    fieldTypes: DOCUMENT_TYPE_FIELDS,
    isMultiple: true,
    validators: [
      {
        type: 'required',
        validator: value =>
          isArray(value) ? !isArrayEmpty(value) : isEmpty(value),
      },
      {
        validator: documetTypes =>
          validateFieldsInList(documetTypes, DOCUMENT_TYPE_FIELDS),
        isMultiple: true,
      },
    ],
  },
];
